import { render, staticRenderFns } from "./AddressTab.vue?vue&type=template&id=6da6e064&scoped=true"
import script from "./AddressTab.vue?vue&type=script&lang=js"
export * from "./AddressTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6e064",
  null
  
)

export default component.exports